// Pure layout logic for the item-detail card renderer. No React imports.

export function splitIntoSections(fields) {
  const sections = [];
  let current = { band: null, fields: [] };
  let started = false;

  const pushCurrent = () => {
    if (current.band !== null || current.fields.length > 0) {
      sections.push(current);
    }
  };

  fields.forEach((field) => {
    if (field.name === '-message-') {
      if (started) pushCurrent();
      current = { band: field.label, fields: [] };
      started = true;
      return;
    }
    if (field.name === '-' || (field.name === '' && field.label === '')) {
      return;
    }
    current.fields.push(field);
    started = true;
  });
  pushCurrent();

  return sections;
}

export function distributeIntoColumns(items, columnCount) {
  const columns = Array.from({ length: columnCount }, () => []);
  items.forEach((item, i) => columns[i % columnCount].push(item));
  while (columns.length > 0 && columns[columns.length - 1].length === 0) {
    columns.pop();
  }
  return columns;
}
